<div id="audioPlayWrap" *ngIf="currentAudio != null"  [ngClass]="showTextModel" (touchmove)="touchmove($event)" (touchend)="touchend()">
	<div class="audioPlay-header">
		<div class="audioPlay-header-inner">
			<audio (canplaythrough)="canplaythrough()" (warting)="warting()" (timeupdate)="timeupdate()" (play)="play()" (pause)="pause()" (ended)="ended()" (loadeddata)="loadeddata()"   crossorigin="*">
			</audio>
			<div *ngIf="showLoading" class="audioLoading"></div>
			<div class="audioPlay-header-title">{{currentAudio.name}}</div>
			<div class="audioPlay-controller" >
				<div class="audioPlay-bar">
					<div class="audioPlay-btn-play" [ngClass]="{'pause':playStatus}" (click)="playAudio()"></div>
					<div class="audioPlay-btn-pre" [ngClass]="{'disable': 0 == currentIndex }" (click)="playPre()"></div>
					<div class="audioPlay-btn-next" [ngClass]="{'disable': (audioList.length -1) == currentIndex }" (click)="playNext()"></div>
					<div class="audioPlay-btn-pre2" (click)="fallback()"></div>
					<div class="audioPlay-btn-next2" (click)="forward()"></div>
				</div>
				<div class="audioPlay-progress">
					<div class="audioPlay-current"></div>
					<div class="audioPlay-play-wrap">
						<div class="audioPlay-play" [ngStyle]="{'width':  audioProcess + '%'}"><div class="audioPlay-playingBar" (touchstart)="touchstart($event)" (mousedown)="touchstart($event)">{{audioProcessTimes}}</div></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div (touchstart)="touchstartContent($event)" (mousedown)="touchstartContent($event)"  class="audioPlay-contents" >
		<div [innerHtml]="currentAudio.audioContent" class="audioPlay-contents-inner"></div>
	</div>
	<div class="audioPlay-footer" [ngClass]="{'show':showToolBar}">
		<div class="audioPlay-footer-btn-view" (click)="showDialog()">查看画像</div> <i class="icon-model-switch" (click)="switchShowModel();"></i>
	</div>
	<div class="common-back-btn-sight" style="position: fixed;z-index: 2;" (click)="exitAudio()">
	    <span>×</span>
	 </div>
</div>
<div id="contentsTip" *ngIf="showTipEnable">
	<div class="inner">
		<div *ngIf="report != null">
			 <div class="report-title">你的DNA画像</div>
			 <div *ngFor="let item of report;let i = index" class="report-item">
	            <div class="report-item-title">
	             	<p><i class="icon">///</i>&nbsp;&nbsp;&nbsp;&nbsp; {{item.name}} &nbsp;&nbsp;&nbsp;&nbsp;<i class="icon">///</i></p>
		            <div class="report-item-point">
		                <span class="enhance">{{item.norm_point}}</span>/100
		            </div>
	            </div>

	            <div [innerHtml] = "item.description"></div>
		     </div>
		</div>
	</div>
	<div class="closer" (click)="closeDialog()"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-audio-play/app-audio-play.component.html